import axios from 'axios';

export enum WordpressSortOption {
  newest = 'Newest',
  aToZ = 'A-Z',
  zToA = 'Z-A',
}

export default class RedisClient {
  static getServices() {
    return this._get('service', true);
  }
  static getServiceCategories() {
    return this._get('service-category');
  }
  static getServiceProductBundles() {
    return this._get('service-product-bundle', true);
  }
  static getCalendarEventTypes() {
    return this._get('cal-event-type', true);
  }

  static getPostsByIds(postIds: string[]) {
    return this._get(`posts?include=${postIds.join(',')}`);
  }
  static searchForPosts(
    searchQuery: string,
    perPage?: number,
    situationSlug?: string,
    tagSlug?: string,
    articleTypeSlug?: string,
    sortBy?: WordpressSortOption
  ) {
    let query = `posts?subtype=post&search=${encodeURIComponent(searchQuery)}`;
    if (perPage) {
      query += `&per_page=${perPage}`;
    }

    let taxonomyIndex = 0;
    if (situationSlug || tagSlug || articleTypeSlug) {
      query += 'filter[tax_query][relation]=OR&';
    }
    if (situationSlug) {
      query += this._addTaxonomy('situation', situationSlug, taxonomyIndex++);
    }
    if (tagSlug) {
      query += this._addTaxonomy('content_tag', tagSlug, taxonomyIndex++);
    }
    if (articleTypeSlug) {
      query += this._addTaxonomy('article-type', articleTypeSlug, taxonomyIndex++);
    }

    if (sortBy) {
      switch (sortBy) {
        case WordpressSortOption.newest:
          query += '&orderby=date&order=desc';
          break;
        case WordpressSortOption.aToZ:
          query += '&orderby=title&order=asc';
          break;
        case WordpressSortOption.zToA:
          query += '&orderby=title&order=desc';
          break;
      }
    }

    query += '&_fields=id';

    return this._get(query, !perPage);
  }

  private static _addTaxonomy(taxonomySlug: string, term: string, index: number): string {
    return `filter[tax_query][${index}][taxonomy]=${taxonomySlug}&filter[tax_query][${index}][field]=slug&filter[tax_query][${index}][terms]=${term}&filter[tax_query][${index}][operator]=IN&filter[tax_query][${index}][include_children]=0&`;
  }

  private static _get(query: string, allPages: boolean = false) {
    return axios.request({
      method: 'GET',
      url: this._createUrl(query, allPages),
    });
  }

  private static _createUrl(query: string, allPages: boolean): string {
    let url = `${process.env.API_CACHE_URL}/url/${encodeURIComponent(`${process.env.WP_API_URL}/${query}`)}`;
    url += '?';
    if (allPages) {
      url += 'proxy-cms-pages=all';
    }
    return url;
  }
}
